import { css } from "styled-components";

export const basicFilledStyle = css`
  color: var(--text-primary);
  background-color: var(--button-filled);
  font-weight: var(--font-weight-regular);
  border: 1px solid var(--button-filled) !important;

  svg:not([data-icon="loading"]) path {
    fill: transparent !important;
    stroke: var(--icon-default) !important;
  }

  &:hover {
    background-color: var(--button-filled-hover) !important;
    color: var(--text-primary) !important;
    border: 1px solid var(--button-filled-hover) !important;

    svg:not([data-icon="loading"]) path {
      fill: transparent !important;
      stroke: var(--icon-default) !important;
    }
  }

  &:focus {
    outline: none !important;
    color: var(--text-primary) !important;
    background-color: var(--button-filled) !important;
    border: 1px solid var(--button-filled) !important;

    svg:not([data-icon="loading"]) path {
      fill: transparent !important;
      stroke: var(--icon-default) !important;
    }
  }

  &:focus-visible {
    outline: 1px solid var(--button-focused-shadow) !important;
    box-shadow: 0 0 0 2px var(--button-focused-shadow) !important;
  }

  &:active {
    background-color: var(--button-filled-hover) !important;
    color: var(--text-primary) !important;
    border: 1px solid var(--button-filled-hover) !important;

    svg:not([data-icon="loading"]) path {
      fill: transparent !important;
      stroke: var(--icon-default) !important;
    }
  }

  &[disabled] {
    color: var(--text-primary);
    background-color: var(--button-filled);
    border: 1px solid var(--button-filled) !important;
    opacity: 0.5;

    &:hover {
      color: var(--text-primary);
      background-color: var(--button-filled);
      border: 1px solid var(--button-filled) !important;
      opacity: 0.5;
    }
  }
`;
